module.exports = __webpack_public_path__ + "img/my-fish.522a9e95.png";